import {userSchema} from "./user";
import {workspaceSchema} from "./workspace";
import {memberSchema} from "./member";
import {sealSchema} from "./seal";
import {documentTemplateSchema} from "./documentTemplate";
import {documentSchema} from "./document";
import {webhookSchema} from "./webhook";

import type {DomainSchemaDefinition} from "../constants";

export const DOMAIN_SCHEMA = {
    ...userSchema,
    ...workspaceSchema,
    ...memberSchema,
    ...sealSchema,
    ...documentTemplateSchema,
    ...documentSchema,
    ...webhookSchema,
} as const satisfies DomainSchemaDefinition;
